import {
  // Page,
  Text,
  View,
} from '@react-pdf/renderer';

import { styles } from '../styles/styles';

export function BodyMainHeaderStyle1(props) {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        // paddingVertical: 8,
        paddingTop: 10,
        paddingBottom: 3,
        borderBottomColor: '#000',
        borderBottomStyle: 'solid',
        borderBottomWidth: 0.5,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>No.</Text>
      </View>
      <View style={{ width: '17%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Code</Text>
      </View>
      <View style={{ width: '25%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Name</Text>
      </View>
      <View style={{ width: '39%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Description</Text>
      </View>
      <View style={{ width: '10%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Qty</Text>
      </View>
      {/* {
                tableFields.map((i, index) => {
                    return (
                        <View
                            key={index}
                            style={{
                                width: i.width,
                                textAlign: i?.align? i.align: '',
                                fontWeight: 800
                            }}
                        >
                            <Text style={[styles.h8, styles.weight, { } ]}>{i.display.toUpperCase()}</Text>
                        </View>
                    )
                })
            } */}
    </View>
  );
}

export function BodyMainHeaderStyle2(props) {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        // paddingVertical: 8,
        paddingTop: 10,
        paddingBottom: 3,
        borderBottomColor: '#000',
        borderBottomStyle: 'solid',
        borderBottomWidth: 0.5,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>No.</Text>
      </View>
      <View style={{ width: '13%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Code</Text>
      </View>
      <View style={{ width: '25%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Name</Text>
      </View>
      <View style={{ width: '8%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>UOM</Text>
      </View>
      <View style={{ width: '8%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Qty</Text>
      </View>
      <View style={{ width: '39%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Instructions</Text>
      </View>
      {/* {
                tableFields.map((i, index) => {
                    return (
                        <View
                            key={index}
                            style={{
                                width: i.width,
                                textAlign: i?.align? i.align: '',
                                fontWeight: 800
                            }}
                        >
                            <Text style={[styles.h8, styles.weight, { } ]}>{i.display.toUpperCase()}</Text>
                        </View>
                    )
                })
            } */}
    </View>
  );
}

export function BodyMainHeaderStyle3(props) {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        // paddingVertical: 8,
        paddingTop: 10,
        paddingBottom: 3,
        borderBottomColor: '#000',
        borderBottomStyle: 'solid',
        borderBottomWidth: 0.5,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>No.</Text>
      </View>
      <View style={{ width: '12%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Code</Text>
      </View>
      <View style={{ width: '20%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Name</Text>
      </View>
      <View style={{ width: '29%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Description</Text>
      </View>
      <View style={{ width: '8%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Qty</Text>
      </View>
      <View style={{ width: '11%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textAlignRight, styles.textUpperCase]}>Price</Text>
      </View>
      <View style={{ width: '11%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textAlignRight, styles.textUpperCase]}>Total</Text>
      </View>
    </View>
  );
}

// item receive
export function BodyMainHeaderStyle4(props) {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        // paddingVertical: 8,
        paddingTop: 10,
        paddingBottom: 3,
        borderBottomColor: '#000',
        borderBottomStyle: 'solid',
        borderBottomWidth: 0.5,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>No.</Text>
      </View>
      <View style={{ width: '12%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Code</Text>
      </View>
      <View style={{ width: '20%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Name</Text>
      </View>
      <View style={{ width: '29%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Description</Text>
      </View>
      <View style={{ width: '8%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Qty</Text>
      </View>
      <View style={{ width: '10%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>UOM</Text>
      </View>
      <View style={{ width: '11%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textAlignRight, styles.textUpperCase]}>Price</Text>
      </View>
    </View>
  );
}

// item transfer
export function BodyMainHeaderStyle5(props) {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        // paddingVertical: 8,
        paddingTop: 10,
        paddingBottom: 3,
        borderBottomColor: '#000',
        borderBottomStyle: 'solid',
        borderBottomWidth: 0.5,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>No.</Text>
      </View>
      <View style={{ width: '12%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Code</Text>
      </View>
      <View style={{ width: '18%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Name</Text>
      </View>
      <View style={{ width: '29%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Description</Text>
      </View>
      <View style={{ width: '8%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Qty</Text>
      </View>
      <View style={{ width: '10%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>UOM</Text>
      </View>
      <View style={{ width: '8%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>In</Text>
      </View>
      <View style={{ width: '8%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Out</Text>
      </View>
      <View style={{ width: '11%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textAlignRight, styles.textUpperCase]}>Strict</Text>
      </View>
    </View>
  );
}

// retail item receive
export function BodyMainHeaderStyle6(props) {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        // paddingVertical: 8,
        paddingTop: 10,
        paddingBottom: 3,
        borderBottomColor: '#000',
        borderBottomStyle: 'solid',
        borderBottomWidth: 0.5,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>No.</Text>
      </View>
      <View style={{ width: '20%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Name</Text>
      </View>
      <View style={{ width: '12%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Code</Text>
      </View>
      <View style={{ width: '12%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Qty</Text>
      </View>
      <View style={{ width: '10%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Balance</Text>
      </View>
    </View>
  );
}

// delivery trips
export function BodyMainHeaderStyle7(props) {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        // paddingVertical: 8,
        paddingTop: 10,
        paddingBottom: 3,
        borderBottomColor: '#000',
        borderBottomStyle: 'solid',
        borderBottomWidth: 0.5,
      }}
    >
      <View style={{ width: '3%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>No.</Text>
      </View>
      <View style={{ width: '13%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Document</Text>
      </View>
      {/* <View style={{ width: '15%' }}>
                <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Document Date</Text>
            </View> */}
      <View style={{ width: '31%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Recipient</Text>
      </View>
      <View style={{ width: '9%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Region</Text>
      </View>
      <View style={{ width: '11%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Collection</Text>
      </View>
      <View style={{ width: '4%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Qty</Text>
      </View>
      <View style={{ width: '12%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Completion</Text>
      </View>
    </View>
  );
}

// Sales CN & DN
export function BodyMainHeaderStyle8(props) {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        // paddingVertical: 8,
        paddingTop: 10,
        paddingBottom: 3,
        borderBottomColor: '#000',
        borderBottomStyle: 'solid',
        borderBottomWidth: 0.5,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>No.</Text>
      </View>
      <View style={{ width: '10%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Code</Text>
      </View>
      <View style={{ width: '17%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Name</Text>
      </View>
      <View style={{ width: '35%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Description</Text>
      </View>
      <View style={{ width: '10%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Qty</Text>
      </View>
      <View style={{ width: '10%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>UOM</Text>
      </View>
      <View style={{ width: '7%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Price</Text>
      </View>
    </View>
  );
}

// item relocate
export function BodyMainHeaderStyle9(props) {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        // paddingVertical: 8,
        paddingTop: 10,
        paddingBottom: 3,
        borderBottomColor: '#000',
        borderBottomStyle: 'solid',
        borderBottomWidth: 0.5,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>No.</Text>
      </View>
      <View style={{ width: '11%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Code</Text>
      </View>
      <View style={{ width: '32%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Name</Text>
      </View>
      <View style={{ width: '12%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Qty</Text>
      </View>
      <View style={{ width: '22%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Inventory</Text>
      </View>
      <View style={{ width: '15%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>From</Text>
      </View>
      <View style={{ width: '8%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>To</Text>
      </View>
    </View>
  );
}

// transfer requisition
export function BodyMainHeaderStyle10(props) {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        // paddingVertical: 8,
        paddingTop: 10,
        paddingBottom: 3,
        borderBottomColor: '#000',
        borderBottomStyle: 'solid',
        borderBottomWidth: 0.5,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>No.</Text>
      </View>
      <View style={{ width: '18%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Code</Text>
      </View>
      <View style={{ width: '12%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Name</Text>
      </View>
      <View style={{ width: '35%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Description</Text>
      </View>
      <View style={{ width: '7%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Qty</Text>
      </View>
      <View style={{ width: '7%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>UOM</Text>
      </View>
    </View>
  );
}

// item adjustment
export function BodyMainHeaderStyle11(props) {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        // paddingVertical: 8,
        paddingTop: 10,
        paddingBottom: 3,
        borderBottomColor: '#000',
        borderBottomStyle: 'solid',
        borderBottomWidth: 0.5,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>No.</Text>
      </View>
      <View style={{ width: '12%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Code</Text>
      </View>
      <View style={{ width: '18%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Name</Text>
      </View>
      <View style={{ width: '29%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Description</Text>
      </View>
      <View style={{ width: '8%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Qty</Text>
      </View>
      <View style={{ width: '10%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>UOM</Text>
      </View>
      <View style={{ width: '8%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>In</Text>
      </View>
      <View style={{ width: '8%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Out</Text>
      </View>
    </View>
  );
}

// pick order
export function BodyMainHeaderStyle12(props) {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        // paddingVertical: 8,
        paddingTop: 10,
        paddingBottom: 3,
        borderBottomColor: '#000',
        borderBottomStyle: 'solid',
        borderBottomWidth: 0.5,
      }}
    >
      <View style={{ width: '3%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>No.</Text>
      </View>

      <View style={{ width: '13%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Document</Text>
      </View>
      {/* <View style={{ width: '15%' }}>
                <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Document Date</Text>
            </View> */}
      <View style={{ width: '31%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Recipient</Text>
      </View>
      <View style={{ width: '9%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Region</Text>
      </View>

      <View style={{ width: '4%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Qty</Text>
      </View>
    </View>
  );
}

// pick order item by document view
export function BodyMainHeaderStyle13(props) {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        // paddingVertical: 8,
        paddingTop: 10,
        paddingBottom: 3,
        borderBottomColor: '#000',
        borderBottomStyle: 'solid',
        borderBottomWidth: 0.5,
      }}
    >
      <View style={{ width: '3%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>No.</Text>
      </View>

      <View style={{ width: '13%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Document No.</Text>
      </View>

      <View style={{ width: '31%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Recipient</Text>
      </View>

      <View style={{ width: '13%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Item Code</Text>
      </View>

      <View style={{ width: '13%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Item Name</Text>
      </View>

      <View style={{ width: '4%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Qty</Text>
      </View>
    </View>
  );
}

// pick order item by location view
export function BodyMainHeaderStyle14(props) {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        // paddingVertical: 8,
        paddingTop: 10,
        paddingBottom: 3,
        borderBottomColor: '#000',
        borderBottomStyle: 'solid',
        borderBottomWidth: 0.5,
      }}
    >
      <View style={{ width: '3%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>No.</Text>
      </View>

      <View style={{ width: '13%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Item Code</Text>
      </View>

      <View style={{ width: '13%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Item Name</Text>
      </View>

      <View style={{ width: '13%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Require Qty</Text>
      </View>

      <View style={{ width: '30%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Available Slot</Text>
      </View>

      <View style={{ width: '10%' }}>
        <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Qty</Text>
      </View>
    </View>
  );
}
